import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const LanguageSwitcher = () => {
  const { lang, setLang } = useLanguage();

  return (
    <div className="lang-switcher">
      <button
        className={`lang-btn${lang === 'en' ? ' lang-btn--active' : ''}`}
        onClick={() => setLang('en')}
      >
        EN
      </button>
      <button
        className={`lang-btn${lang === 'fr' ? ' lang-btn--active' : ''}`}
        onClick={() => setLang('fr')}
      >
        FR
      </button>
    </div>
  );
};

export default LanguageSwitcher;
